export default __webpack_public_path__ + "static/media/eduBlack.ffbd9a23.svg";